import useCustomFieldsHook from "@/hooks/use-custom-fields.hook.tsx";
import {
  OfferSystemFieldDisplayValues,
  useOfferSystemFieldValue,
} from "@/pages/recruit/offers/components/use-offer-system-field-value.ts";
import { offerHideConfigKeys } from "@/pages/recruit/offers/offer-edit-fields.ts";
import { ApiField } from "@/types/custom-field.types.ts";
import { useOfferEditContext } from "@/types/recruit/offer.types.ts";
import { Button, ListItem } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export function OfferPreviewSystemField({
  field,
  values,
}: {
  field: ApiField;
  values: OfferSystemFieldDisplayValues;
}) {
  const { t } = useTranslation();
  const { getFieldTitle } = useCustomFieldsHook();
  const getValue = useOfferSystemFieldValue();
  const { offerConfig, handleUpdateConfig } = useOfferEditContext();
  const value = getValue(field.type, values) ?? { title: "" };
  const hideKey = offerHideConfigKeys[field.type];

  if (!hideKey) {
    return <ListItem preTitle={getFieldTitle(field)} title={value.title} caption={value.caption} />;
  }

  const isHidden = offerConfig[hideKey];

  return (
    <ListItem
      preTitle={getFieldTitle(field)}
      caption={value.caption}
      titleSlot={
        <div className={isHidden ? "line-through text-dark/60" : "text-title"}>{value.title}</div>
      }
      valueSlot={
        <Button variant="plain" onClick={() => handleUpdateConfig(hideKey, !isHidden)}>
          {isHidden ? t("common:show") : t("common:hide")}
        </Button>
      }
    />
  );
}
